
// import RadarGraph from "../../Components/RadarGraph";

function AssessmentResult() {
  return <div></div>;
}

export default AssessmentResult;
